import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    search: undefined,
  },
  isOpenModalDelete: false,
}

export const eventParticipantSlice = createAppSlice({
  name: 'eventParticipant',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    toggleModalDelete: create.reducer((state) => {
      state.isOpenModalDelete = !state.isOpenModalDelete
    }),
  }),
  extraReducers: (builder) => {},
})

export const { setFetchOption, toggleModalDelete } =
  eventParticipantSlice.actions

export default eventParticipantSlice.reducer
